(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup'); // Sticky bar
		const secondSection = document.querySelector('.product-section + section'); // Second section
		const footer = document.querySelector('footer'); // Footer

		// Check if the required elements exist
		if (!stickyBar || !secondSection || !footer) {
				console.error('Required elements not found!');
				return;
		}

			const getOffset = (element) => {
				const rect = element.getBoundingClientRect();
				return rect.top + window.scrollY;
			};

			const secondSectionMid = getOffset(secondSection);
			const footerTop = getOffset(footer);

			const handleScroll = () => {
				const scrollPosition = window.scrollY + window.innerHeight;
				const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;

				stickyBar.classList[activeOffset ? "add" : "remove"]('active');
			};

			// Initial check in case the user starts in the middle of the page
			handleScroll();
};

	document.addEventListener('scroll', () => revealPopup());


	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);

class ProductAddons extends HTMLElement {
	constructor() {
		super();
		this.sectionId = this.dataset.sectionId;
		this.mainProductId = this.dataset.productId;
		this.mainVariantId = this.dataset.variantId;
		this.originalPrice = this.dataset.productPrice;
		this.selectedAddon = {
			title: 'None',
			handle: null,
			price: 0,
			productId: null,
			variantId: null,
			image: null
		};
		this.alreadySubmitting = false;
		this.isInitialized = false;
	}

	connectedCallback() {
		if (this.isInitialized) return;
		
		//console.log('Product Addons: Connected for section', this.sectionId);
		this.init();
	}

	init() {
		this.addonInputs = this.querySelectorAll('.swatch-input__input');
		//console.log('Product Addons: Found addon inputs:', this.addonInputs);
		this.selectedDisplay = this.querySelector('[data-addon-selected]');
		this.priceElement = this.findPriceElement();
		//console.log('Product Addons: Found price element:', this.priceElement);
		this.productGallery = this.findSwiperGallery('.product__media-list');
		this.thumbnailGallery = this.findSwiperGallery('.product__media-sublist');
		//console.log('Product Addons: Found product gallery:', this.productGallery);
		this.originalImages = this.storeOriginalImages();
		//console.log('Product Addons: Stored original images:', this.originalImages);
		
		// Find modal image containers
		this.modalMainProductImage = document.querySelector('.popup-image-main-product');
		this.modalAddonImage = document.querySelector('.popup-image-addon-veil');

		this.attachEventListeners();
		this.initializeSelection();
		//this.setupFormIntercept();
		
		this.isInitialized = true;
		//console.log('Product Addons: Initialization complete for section', this.sectionId);
	}

	findPriceElement() {
		const selectors = [
			`#MainProduct-${this.sectionId} .price__regular .price-item--regular`,
			`.product__popup .price__regular .price-item--regular`,
		];

		for (const selector of selectors) {
			const element = document.querySelector(selector);
			if (element) return element;
		}

		return null;
	}

	findSwiperGallery(elementClass) {
		const selectors = [
			`#MainProduct-${this.sectionId} ${elementClass}`,
			`.product__popup .media`
		];

		for (const selector of selectors) {
			const element = document.querySelector(selector);
			if (element) return element;
		}

		return null;
	}

	storeOriginalImages() {
		const images = [];
		if (this.productGallery) {
			const imgElements = this.productGallery.querySelectorAll('img');
			imgElements.forEach(img => {
				images.push({
					src: img.src,
					srcset: img.srcset,
					alt: img.alt
				});
			});
		}
		return images;
	}

	attachEventListeners() {
		this.addonInputs.forEach(input => {
			input.addEventListener('change', () => {
				if (input.checked) {
					this.handleAddonChange(input);
				}
			});
		});
	}

	getUrlParameter(name) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name);
	}

	updateUrlParameter(handle) {
		const url = new URL(window.location.href);
		
		if (handle && handle !== 'none') {
			url.searchParams.set('veil', handle);
		} else {
			url.searchParams.delete('veil');
		}
		
		// Update URL without reloading the page
		window.history.replaceState({}, '', url);
	}

	initializeSelection() {
		// Check if there's a veil parameter in the URL
		const veilParam = this.getUrlParameter('veil');
		let checkedInput = null;
		
		if (veilParam) {
			// Try to find addon with matching handle
			checkedInput = this.querySelector(`.swatch-input__input[data-addon-handle="${veilParam}"]`);
			if (checkedInput) {
				checkedInput.checked = true;
				//console.log('Product Addons: Selected addon from URL parameter:', veilParam);
			}
		}
		
		// If no URL param or addon not found, use the checked input
		if (!checkedInput) {
			checkedInput = this.querySelector('.swatch-input__input:checked');
		}
		
		if (!checkedInput) {
			//console.log('Product Addons: No checked input found, defaulting to None');
			checkedInput = this.querySelector('#addon-none');
			if (checkedInput) {
				checkedInput.checked = true;
			}
		}
		
		if (checkedInput) {
			const parentSwatch = checkedInput.closest('.swatch-input__swatch');
			if (parentSwatch) {
				parentSwatch.classList.add('swatch-input__swatch--selected');
				//console.log('Product Addons: Added selected class to', checkedInput.id);
			}
			
			this.selectedAddon = {
				title: checkedInput.dataset.addonTitle || 'None',
				handle: checkedInput.dataset.addonHandle || null,
				price: checkedInput.dataset.addonPrice || null,
				productId: checkedInput.dataset.addonProductId || null,
				variantId: checkedInput.dataset.addonVariantId || null,
				image: checkedInput.dataset.addonImage || null
			};
			
			this.updateSelectedDisplay();
			this.updateProductPrice();
			this.updateProductImages(this.productGallery, true);
			this.updateProductImages(this.thumbnailGallery);
			this.updateModalImages();
			this.updateProductFormInputs();
		}
	}

	handleAddonChange(input) {

		if (input.dataset.isOutOfStock === 'true') {
			console.warn('Product Addons: Selected addon is out of stock, reverting selection');
			return;
		}

		this.selectedAddon = {
			title: input.dataset.addonTitle || 'None',
			handle: input.dataset.addonHandle || null,
			price: input.dataset.addonPrice || null,
			productId: input.dataset.addonProductId || null,
			variantId: input.dataset.addonVariantId || null,
			image: input.dataset.addonImage || null
		};

		// Update URL parameter
		this.updateUrlParameter(this.selectedAddon.handle);

		// Update visual state
		this.querySelectorAll('.swatch-input__swatch').forEach(swatch => {
			swatch.classList.remove('swatch-input__swatch--selected');
		});
		
		const parentSwatch = input.closest('.swatch-input__swatch');
		if (parentSwatch) {
			parentSwatch.classList.add('swatch-input__swatch--selected');
		}

		this.updateSelectedDisplay();
		this.updateProductPrice();
		this.updateProductImages(this.productGallery, true);
		this.updateProductImages(this.thumbnailGallery);
		this.updateModalImages();
		this.updateProductFormInputs();
	}

	updateSelectedDisplay() {
		if (this.selectedDisplay) {
			if (this.selectedAddon.title === 'None') {
				this.selectedDisplay.textContent = 'None';
			} else {
				//const priceFormatted = this.formatMoney(this.selectedAddon.price);
				this.selectedDisplay.textContent = `${this.selectedAddon.title}`;
			}
		}
	}

	updateProductPrice() {
		if (!this.priceElement) return;

		if (!this.originalPrice || !this.selectedAddon?.price) {
			console.warn('Product Addons: Cannot update price - original price is 0 or invalid');
			return;
		}

		let total = this.originalPrice;

		if (this.selectedAddon.variantId) {
			total = this.selectedAddon.price;
		}

		this.priceElement.textContent = total;
	}

	updateProductImages(gallery, isMainGallery = false) {
		if (!gallery) return;

		const sizes = `(min-width: 1100px) calc((100vw - 10rem) / 2), (min-width: 750px) calc((100vw - 10rem) / 2), calc(100vw - 4rem)`;
		const widths = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2400, 2600, 2800, 3000, 3200, 3400, 3600, 3800, 4000, 4200, 4400, 4600, 4800, 5000];
		const swiper = gallery?.swiper;

		if (!swiper) {
			//Quickfix for floating form main image update
			if (isMainGallery) {
				//console.warn('Product Addons: Trying to update main product image in popup gallery');
				const img = gallery.querySelector('img');
				if (img) {
					if (this.selectedAddon.image && this.selectedAddon.title !== 'None') {
						img.src = this.selectedAddon.image;
						const srcsetArray = widths.map(size => `${this.selectedAddon.image}?width=${size} ${size}w`);
						img.srcset = srcsetArray.join(', ');
						img.sizes = sizes;
						//console.log('Product Addons: Updated popup main product image to addon image:', this.selectedAddon.image);
					} else if (this.originalImages.length > 0) {
						img.src = this.originalImages[0].src;
						const srcsetArray = widths.map(size => `${this.originalImages[0].src}?width=${size} ${size}w`);
						img.srcset = srcsetArray.join(', ');
						img.sizes = sizes;
					}
				}
			}
			//console.warn('Product Addons: Swiper instance not found for product gallery');
			return;
		}

		// Append addon image if selected
		if (this.selectedAddon.image && this.selectedAddon.title !== 'None') {
			// Check if addon image already exists in swiper
			const existingSlide = Array.from(swiper.slides).find(slide => {
				const img = slide.querySelector('img');
				return img && img.src.includes(this.selectedAddon.image);
			});

			if (!existingSlide) {
				const copySlide = swiper.slides[0].cloneNode(true);
				const imgElement = copySlide.querySelector('img');
				imgElement.alt = this.selectedAddon.title || 'Addon Product';
				imgElement.dataset.addonImage = 'true';
				const srcsetArray = widths.map(size => `${this.selectedAddon.image}?width=${size} ${size}w`);

				//console.log('Product Addons: Adding addon image to swiper:', this.selectedAddon.image);

				imgElement.src = this.selectedAddon.image;
				imgElement.srcset = srcsetArray.join(', ');
				imgElement.sizes = sizes;

				swiper.addSlide(0, copySlide);
				swiper.slideTo(0);
			}
		} else {
			// Remove addon image if exists
			// Check if first image is addon image
			const firstSlide = swiper.slides[0];
			const firstImg = firstSlide.querySelector('img');
			if (firstImg.dataset.addonImage === 'true') {
				//console.log('Product Addons: Removing addon image from swiper');
				swiper.removeSlide(0);
			}
		}
	}

	updateModalImages() {
		// Update main product image in modal
		if (this.modalMainProductImage && this.originalImages.length > 0) {
			const mainProductImg = this.originalImages[0];
			const imgElement = document.createElement('img');
			imgElement.src = mainProductImg.src;
			imgElement.alt = mainProductImg.alt || 'Main Product';
			imgElement.loading = 'lazy';
			imgElement.width = '200';
			imgElement.height = '250';

			this.modalMainProductImage.innerHTML = '';
			this.modalMainProductImage.appendChild(imgElement);
		}

		// Update addon image in modal
		if (this.modalAddonImage) {
			if (this.selectedAddon.image && this.selectedAddon.title !== 'None') {
				const addonImgElement = document.createElement('img');
				addonImgElement.src = this.selectedAddon.image;
				addonImgElement.alt = this.selectedAddon.title || 'Addon Product';
				addonImgElement.loading = 'lazy';
				addonImgElement.width = '200';
				addonImgElement.height = '250';
				
				this.modalAddonImage.innerHTML = '';
				this.modalAddonImage.appendChild(addonImgElement);
			} else {
				// GET FIRST addon option image
				const firstAddonOption = this.addonInputs[1]; // Assuming first option is 'None', get second input
				const firstAddonImage = firstAddonOption ? firstAddonOption.dataset.addonImage : null;
				const firstAddonTitle = firstAddonOption ? firstAddonOption.dataset.addonTitle : null;
				
				if (firstAddonOption && firstAddonImage) {
					const firstAddonImgElement = document.createElement('img');
					firstAddonImgElement.src = firstAddonImage;
					firstAddonImgElement.alt = firstAddonTitle || 'Addon Option';
					firstAddonImgElement.loading = 'lazy';
					firstAddonImgElement.width = '200';
					firstAddonImgElement.height = '250';

					this.modalAddonImage.innerHTML = '';
					this.modalAddonImage.appendChild(firstAddonImgElement);
				} else {
					// Clear addon image if none selected
					this.modalAddonImage.innerHTML = '';
				}
			}
		}
	}

	updateProductFormInputs() {
		const productForm = document.querySelector(`#MainProduct-${this.sectionId} product-form form`) ||
											document.querySelector(`.product__popup product-form form`);

		if (!productForm || !productForm) {
			console.warn('Product Addons: Could not find add to cart form');
			return;
		}

		const variantInput = productForm.querySelector('[name="id"]');
		if (!variantInput) {
			console.warn('Product Addons: Could not find variant input');
			return;
		}

		const productIdInput = productForm.querySelector('[name="product-id"]');
		if (!productIdInput) {
			console.warn('Product Addons: Could not find product_id input');
			return;
		}

		if (this.selectedAddon && this.selectedAddon.variantId) {
			variantInput.value = this.selectedAddon.variantId;	
			productIdInput.value = this.selectedAddon.productId;
		} else {
			variantInput.value = this.mainVariantId;
			productIdInput.value = this.mainProductId;
		}
	}

	formatMoney(cents) {
		return formatMoney(cents);
	}
}

customElements.define("product-addons", ProductAddons);

class SwatchProductPicker extends HTMLElement {
	constructor() {
		super();
		this.sectionId = this.dataset.sectionId;
		this.isInitialized = false;
	}

	connectedCallback() {
		if (this.isInitialized) return;
		this.init();
	}

	init() {
		this.addonInputs = this.querySelectorAll('.swatch-input__input');
		this.selectedDisplay = this.querySelector('[data-addon-selected]');
		
		this.isInitialized = true;
	}

	attachEventListeners() {
		this.addonInputs.forEach(input => {
			input.addEventListener('change', () => {
				if (input.checked) {
					this.handleAddonChange(input);
				}
			});
		});
	}
}

customElements.define("swatch-product-picker", SwatchProductPicker);
